/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import { FontWeight, Text } from "../Text";
import { Breakpoints } from "../../constants/Breakpoints";
import globalStyles from "globalStyles";
const { menu } = globalStyles.components;

const Content = styled.div`
  width: 340px;
  float: left;
  padding-top: 0px;
  margin-bottom: 0;
  height: 100%;

  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-bottom: -10px;
  }
`;

const Container = styled.div`
  width: 315px;
  min-height: 100%;
  height: 100%;
  position: relative;
  background: #fff;
`;

const Logo = styled.img`
  width: 65%;
  margin: 15px;
  padding-left: 30px;
  padding-right: 10px;
  
  @media screen and (max-width: 768px) {
    max-width: 70%;
    height: auto;
  @media screen and (min-width: ${Breakpoints.sm}) {
    width: 70%;
    height: auto;
    margin: 30px 0 10px;
  }
`;

const Title = styled(Text)`
  font-weight: ${FontWeight.SemiBold};
  color: ${menu.title};
  font-size: 14px;
  padding-left: 55px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const List = styled.ul`
  width: 100%;
  height: calc(95vh - 320px);
  overflow: auto;
  list-style-type: none;
  padding-inline-start: 0px;
  margin-top: 5px;
  a {
    text-decoration: none;
  }

  .active span {
    color: ${menu.title};
    margin-left: 0px;
    padding-left: 51px;
    border-left: 4px solid ${menu.activeItemBorder};
    background: #fff;
    border-radius: 4px;
    box-shadow: 7px 5px 16px 4px rgba(177, 175, 175, 0.19);
  }

  .active i::before {
      background-color: ${menu.activeItemBackgroundColor};;
    }
`;

const Item = styled(Text)`
   color: ${menu.inactiveItem};
  font-weight: ${FontWeight.Bold};
  align-items: center;
  padding-left: 55px;
  line-height: 50px;
  height: 45px;
  display: flex;
  cursor: pointer;
  gap: 20px;
}
  
  i {
    color: ${menu.title};
    font-size: 27px;
  }
`;

const Settings = styled.div`
  bottom: 0;
  margin-left: 20px;
  margin-top: 20px;
  left: 0px;
  max-height: 175px;

  span {
    line-height: 10px;
    font-weight: ${FontWeight.Bold};
    padding-left: 35px;
    i {
      margin-top: 0px;
    }
  }

  @media screen and (min-width: ${Breakpoints.sm}) {
    position: unset;
    bottom: 30px;
  }

  @media screen and (min-width: ${Breakpoints.lg}) {
    margin-top: unset;
  }
`;

const SubTitle = styled(Text)`
  font-weight: ${FontWeight.SemiBold};
  color: ${menu.subtitle};
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
  text-transform: uppercase;
  display: block;
  padding-top: 10px;
`;
const Version = styled.div`
	bottom: 0;	
	margin-left: 55px;
	padding-bottom: 10px;

	@media screen and (max-width: ${Breakpoints.sm}) {
		padding-bottom: 10px;
	}
`;

const SubTitleVersion = styled(SubTitle)`
	font-size: 14px;
	font-weight: ${FontWeight.Bold};
	line-height: 20px;
	letter-spacing: unset;
	margin: 0;
`;

const TextVersion = styled(Text)`
  font-size: 12px;
	line-height: 16px;
  letter-spacing: 1px;
  font-weight: ${FontWeight.SemiBold};
  color: ${menu.inactiveItem};
`;

export { Container, Logo, Title, List, Item, Settings, SubTitle, Content, Version, SubTitleVersion, TextVersion };
